import { transition, trigger } from '@angular/animations';

/**
 * Sem animação de rota — evita stretch horizontal e jump vertical
 * causados por styles temporários do Angular Animations.
 * O trigger permanece para [@routeTransition] continuar avaliando prepareRoute
 * (ex.: highlight de item de menu).
 */
export const fader = trigger('routeTransition', [transition('* <=> *', [])]);
